import { Typography } from '@recruit-robin/robin-theme/web-components';
import { memo, useCallback } from 'react';

import type { JobListItemViewModel } from '../../models';

import { useStyles } from './JobList.styles';
import { JobListItem } from './JobListItem';
import { useDictionary } from '@/shared/lib/i18n';

export type JobListProps = {
  items: JobListItemViewModel[];
  selectedId: string | null;
  onSelect: (item: JobListItemViewModel) => void;
  emptyMessage?: string;
  onEditJob?: (jobId: string) => void;
};

export const JobList = memo(({ items, selectedId, onSelect, emptyMessage, onEditJob }: JobListProps) => {
  const classes = useStyles();
  const dictionary = useDictionary();

  const handleSelect = useCallback(
    (item: JobListItemViewModel) => {
      onSelect(item);
    },
    [onSelect],
  );

  if (items.length === 0) {
    return (
      <div css={classes.empty}>
        <Typography variant={(v) => v.supporting.helper} color={(c) => c.neutral.variant[60]}>
          {emptyMessage ?? dictionary.noVacanciesFound}
        </Typography>
      </div>
    );
  }

  return (
    <div css={classes.listContainer}>
      {items.map((item) => (
        <JobListItem
          key={`job-list-${item.id}-${item.name}-${item.type}`}
          item={item}
          isSelected={item.id === selectedId}
          onSelect={handleSelect}
          onEditJob={onEditJob}
        />
      ))}
    </div>
  );
});

JobList.displayName = 'JobList';
